import { FeatureFlags } from '../lib/util/flags/types';

import useFlags from './useFlags';

/**
 * Global trading kill-switch driven by the `maintenance` feature flag. While it
 * is on, every Buy/Sell entry point is replaced by the maintenance notice.
 *
 * Defaults to `false` so an unreachable BFF can never block trading - losing
 * the kill-switch is recoverable, wrongly suspending trading is not. That is
 * also what the flag reads as before the session is established, since the
 * flags endpoint is only reachable with a valid BFF session.
 *
 * Flag changes arrive over the BFF SSE stream, so turning the flag off restores
 * trading without a refresh.
 */
const useMaintenanceMode = (): boolean => {
  const flags = useFlags([ FeatureFlags.maintenance ]);

  return flags[FeatureFlags.maintenance].enabled;
};

export default useMaintenanceMode;
